import { ReactChild } from 'react'
import { ToggleSwitch as CosmaToggleSwitch } from 'is24-corecss'
import styled from 'styled-components'

type StyledToggleSwitchProps = {
  backgroundColor?: string
  checkedColor?: string
  'data-testid'?: string
  label?: ReactChild
} & JSX.IntrinsicElements['input']

const StyledToggleSwitch = styled(CosmaToggleSwitch)`
  #rle-wizard & {
    ${(props: StyledToggleSwitchProps) =>
      props.checkedColor &&
      `
      &&:checked+::before {
        background-color: ${props.checkedColor} !important;
        border-color: ${props.checkedColor} !important;
      }`}
    ${(props: StyledToggleSwitchProps) =>
      props.backgroundColor &&
      `
      + ::before {
        background-color: ${props.backgroundColor} !important;
        border-color: ${props.backgroundColor} !important;
    }`}
  }
`

export default StyledToggleSwitch
